import React from 'react'
import Sidebar from '../../Components/Sidebar'
import TopHeader from '../../Components/TopHeader'
import { Link } from 'react-router'
import TestimonialForm from './TestimonialForm'
import TestimonialPageForm from './TestimonialPageForm'
import TestimonialDisplay from './TestimonialDisplay'

const Testimonial = () => {
    return (
        <div>
            <div id="admin-dashboard" className="flex h-[800px] bg-neutral-100">
                <Sidebar />
                <div id="main-content" className="flex-1 flex flex-col overflow-hidden">
                    <TopHeader pageName="Testimonial" />
                    <div id="content-container" className="flex-1 overflow-auto p-6">
                        <TestimonialPageForm />
                        <TestimonialDisplay />
                        {/* <TestimonialForm /> */}

                        {/* <div class="flex justify-between items-center mb-6">
                            <div>
                                <h2 class="text-2xl text-neutral-800">Projects</h2>
                                <p class="text-neutral-600">Manage concrete project entries and case studies</p>
                            </div>
                            <Link to='/projects/form' class="bg-neutral-900 text-white px-4 py-2 rounded-md text-sm flex items-center">
                                <i class="fa-solid fa-plus mr-2"></i>
                                Add New Project
                            </Link>
                        </div> 
                        */}
                        {/* <DisplayProject /> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Testimonial
